export function toDatetimeLocalValue(date: Date): string {
  if (Number.isNaN(date.getTime())) return "";

  const pad = (value: number) => String(value).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function datetimeLocalToIso(value: string): string | null {
  const normalized = value.trim();
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(normalized)) return null;

  const date = new Date(normalized);
  if (
    Number.isNaN(date.getTime()) ||
    toDatetimeLocalValue(date) !== normalized
  ) {
    return null;
  }

  return date.toISOString();
}
